export default __webpack_public_path__ + "static/media/set_5_360-4.b2b87a61.svg";